import axios from 'axios';
import { defineStore } from 'pinia';
import { useStoreCountry } from '../client/country';
import type { IRequestOptions } from '~/types/transport/requestOptions';

export const bitBack = defineStore('transportBitBack', {
  actions: {
    async get(requestOptions: IRequestOptions) {
      try {
        const host = useRuntimeConfig().public.BIT_BACKEND_HOST;
        const url = `${host}${requestOptions.url || ''}`;

        const headers: {
          [key: string]: string;
        } = {
          geo: useStoreCountry().country,
          userId: requestOptions.userId || '',
        };

        const response = await axios.get(url, {
          withCredentials: !!requestOptions.withCredentials,
          headers,
        });

        return response.data || null;
      } catch (e: any) {
        console.error(e);
        return null;
      }
    },
  },
});
